import { render, staticRenderFns } from "./CustomControllers.vue?vue&type=template&id=84bc1f3a&"
import script from "./CustomControllers.vue?vue&type=script&lang=js&"
export * from "./CustomControllers.vue?vue&type=script&lang=js&"
import style0 from "./CustomControllers.vue?vue&type=style&index=0&id=84bc1f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports